import { PENDING_COUNTRY_QUERY_KEY, PENDING_STATE_QUERY_KEY } from '@src/constants';
import { useAccount, useEnv, useToasts } from '@src/contexts';
import { configureInterceptors } from '@src/services/api-service';
import React, { lazy, ReactNode, Suspense, useEffect } from 'react';
import { useSearchParams } from 'react-router-dom';

const BrowserSupportNotice = lazy(() => import('@src/components/browserSupportNotice'));
const AutoLogout = lazy(() => import('@src/components/autoLogout'));

interface Props {
  children?: ReactNode;
}

const AppLayoutInner = ({ children }: Props) => {
  const { USER_AUTO_LOGOUT_DURATION_MS } = useEnv();
  const { logout, handleLogoutSuccess } = useAccount();
  const { addToast } = useToasts();

  const [searchParams] = useSearchParams();

  const mockUserCountry = searchParams.get(PENDING_COUNTRY_QUERY_KEY);
  const mockUserState = searchParams.get(PENDING_STATE_QUERY_KEY);

  useEffect(() => {
    handleSaveMockLocation();

    return configureInterceptors({ addToast, logout, handleLogoutSuccess });
  }, [addToast, logout]);

  const handleSaveMockLocation = () => {
    if (mockUserCountry && mockUserState) {
      sessionStorage.setItem(PENDING_COUNTRY_QUERY_KEY, mockUserCountry);
      sessionStorage.setItem(PENDING_STATE_QUERY_KEY, mockUserState);
    }
  };

  return (
    <>
      {children}
      <Suspense>
        <BrowserSupportNotice />
      </Suspense>
      <Suspense>
        <AutoLogout inactivityDuration={USER_AUTO_LOGOUT_DURATION_MS} />
      </Suspense>
    </>
  );
};

export default AppLayoutInner;
